import { createFileRoute } from '@tanstack/react-router'

import { preloadListSalesChannelGroups } from '@/api/react-query'

export const Route = createFileRoute('/_authenticated/settings/sales-channels/groups')({
	loader: async ({ context }) => await preloadListSalesChannelGroups(context, {}),
	staticData: {
		crumb: ({ context: { L } }) => L.Settings.SalesChannels.Groups.Title()
	}
})
